module.exports = __webpack_public_path__ + "04_mid_grey.5b28522e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/04_mid_grey.png
// module id = e1qx
// module chunks = 0